import { TableView, Form, OfficeTool, OfficeGroup, QuickPanel, Unit } from './data/index'

export default { TableView, Form, OfficeTool, OfficeGroup, QuickPanel, Unit }
